import React, { useState, useEffect, useContext } from "react";

import Table from "../../common/Table";

import { Link } from "react-router-dom";

import db from "../../../services/query";
import { HalfYearContext } from "../../../contexts/halfYearContext";

const IndirectExpenses = ({halfYearId}) => {
  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "budget_code",
      label: "کد بودجه",
    },
    {
      path: "name",
      label: "نام",
      content: (e) => (
        <Link to={`/mis/expenses/types/4/accounts/${e.id}`}>{e.name}</Link>
      ),
    },
    {
      path: "budget",
      label: "بودجه",
    },
    {
      path: "paid",
      label: "پرداخت شده",
    },
    {
      path: "balance",
      label: "باقیمانده",
    },
    { path: "option" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `expenses/types/4/accounts?halfYearId=${halfYearId || halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return <Table data={data} columns={columns} />;
};

export default IndirectExpenses;
